import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CoreConfirmationConfig } from '@core/services/confirmation/confirmation.types';

@Component({
    selector     : 'core-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CoreConfirmationDialogComponent implements OnInit
{
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CoreConfirmationConfig,
        public matDialogRef: MatDialogRef<CoreConfirmationDialogComponent>
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

}
